import type { ReactNode } from "react";
import Box from "@mui/material/Box";

export interface ListGridExpandedField {
  label: string;
  value: ReactNode;
  isWrapping?: boolean;
}

interface ListGridExpandedFieldsProps {
  fields: ListGridExpandedField[];
}

/** Label / value pairs in an expanded ListGrid row's section; values are cut with "…" unless the field wraps. */
export const ListGridExpandedFields = (props: ListGridExpandedFieldsProps) => {
  const { fields } = props;

  return (
    <Box
      component="dl"
      sx={{
        columnGap: 2,
        display: "grid",
        gridTemplateColumns: "max-content minmax(0, 1fr)",
        m: 0,
        rowGap: 1,
        typography: "body2",
      }}
    >
      {fields.map((field) => (
        <Box
          key={field.label}
          sx={{ display: "contents" }}
        >
          <Box
            component="dt"
            sx={{ color: "text.secondary" }}
          >
            {field.label}
          </Box>
          <Box
            component="dd"
            sx={{
              fontVariantNumeric: "tabular-nums",
              m: 0,
              minWidth: 0,
              overflow: "hidden",
              overflowWrap: field.isWrapping ? "anywhere" : "normal",
              textAlign: "right",
              textOverflow: field.isWrapping ? "clip" : "ellipsis",
              whiteSpace: field.isWrapping ? "normal" : "nowrap",
            }}
          >
            {field.value}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
